module.exports = __webpack_public_path__ + "static/media/masive.1a8837e3.png";